import { useState, useRef, useEffect } from 'react'; // <-- 1. useEffect eklendi
import { fetchCompanyContract } from "../../../../../api/requests/payment-requests";
import defaultContractText from "../../../../../constants/defaultContractText"

export const usePaymentModals = (companyId, validation, profile, accounts) => {
    const [showContract, setShowContract] = useState(false);
    const [contractText, setContractText] = useState('');
    const [contractAccepted, setContractAccepted] = useState(false);
    const [instantModalOpen, setInstantModalOpen] = useState(false);
    const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
    const [errorMessage, setErrorMessage] = useState(''); // Sözleşme hatası için
    const linkCreationSuccess = useRef(false);

    // 2. YENİ: Hata mesajını 5 saniye sonra temizlemek için useEffect
    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => {
                setErrorMessage('');
            }, 5000); // 5 saniye

            // Component unmount olursa veya errorMessage değişirse timer'ı temizle
            return () => clearTimeout(timer);
        }
    }, [errorMessage]); // Sadece errorMessage değiştiğinde tetiklenir

    // Anlık Ödeme Linki Modal'ı için
    const handleInstantModalToggle = () => {
        // ... (bu kısım aynı)
        if (instantModalOpen && !linkCreationSuccess.current) {
            setShowCloseConfirmation(true);
        } else {
            setInstantModalOpen(!instantModalOpen);
            if (linkCreationSuccess.current) {
                linkCreationSuccess.current = false;
            }
        }
    };

    const handleLinkCreationSuccess = () => {
        linkCreationSuccess.current = true;
    };

    const confirmCloseModal = () => {
        setInstantModalOpen(false);
        setShowCloseConfirmation(false);
    };

    const cancelCloseModal = () => {
        setShowCloseConfirmation(false);
    };

    // Sözleşme Modal'ı için
    const handleOpenContract = async (canProceedBase) => {
        if (!canProceedBase) {
            setErrorMessage('Önce zorunlu alanları doldurun (tutar, kart bilgileri ve cari/fatura bilgisi).');
            return;
        }

        // 3. YENİ: Tekrar deneme durumunda eski hatayı anında temizle
        // Bu, "hatasız geldiğinde kaybolmalı" şartını karşılar.
        setErrorMessage('');

        try {
            const amtTL = Number(validation.values.amount) || 0;

            const selectedAccountId = validation.values.accountId;
               const selectedAccount =
                     selectedAccountId && Array.isArray(accounts)
                       ? accounts.find(a => a.id === selectedAccountId)
                           : null;

                   const accountDisplayName =
                     selectedAccount?.name ??
                     selectedAccount?.companyName ??
                     selectedAccount?.title ??
                     selectedAccount?.displayName ??
                     null;
            const payload = {
                companyId,
                accountId: validation.values.accountId || null,
                invoiceCompanyName: validation.values.accountId ? null : (validation.values.invoiceCompanyName || null),
                amountTL: Number(amtTL.toFixed(2)),
                debtorName: selectedAccountId
                        ? (accountDisplayName || profile.userName)
                             : (validation.values.invoiceCompanyName || profile.userName)
            };

            const res = await fetchCompanyContract(payload);

            const { data, statusCode, message } = await res.json().catch(() => ({}));

            if (!res.ok || statusCode !== 200 || !data) {
                console.warn("⚠️ API sözleşme metni alınamadı, default gösteriliyor:", message);
                setContractText(defaultContractText);
                setShowContract(true);
                return;
            }
            setContractText(data);
            setShowContract(true);
        } catch (err) {
            setErrorMessage(err.message || 'Sözleşme alınırken bir hata oluştu.');
        }
    };

    const handleAcceptContract = () => {
        setContractAccepted(true);
        setShowContract(false);
    };

    const handleCloseContract = () => {
        setShowContract(false);
    };

    return {
        // Contract Modal
        showContract,
        contractText,
        contractAccepted,
        handleOpenContract,
        handleAcceptContract,
        handleCloseContract,
        // Instant Link Modal
        instantModalOpen,
        handleInstantModalToggle,
        handleLinkCreationSuccess,
        // Close Confirmation Modal
        showCloseConfirmation,
        confirmCloseModal,
        cancelCloseModal,
        // Error
        modalErrorMessage: errorMessage, // Ayrı bir hata state'i
        setModalErrorMessage: setErrorMessage
    };
};